/**
 * The dot that sits on the changed element itself — the third level of D1.
 *
 * Small, quiet, and never the only information: it carries a `title` and an accessible label,
 * because a coloured dot says nothing to a screen reader and not much to anybody who has not
 * been told what it means.
 *
 * Green and not amber. In this app amber means "a person has to act" (design.md §2,
 * `npm run scan:tokens`), and a new feature is not an overdue invoice. The dot is `--brand`
 * itself, which design.md §2 permits for the wordmark and the brand bar and nothing else: a 6 px
 * dot is a MARK, not text and not a button, so its 3.27:1 is what that token is for.
 *
 * The class was `bg-blue-500` on arrival, with a comment saying `blue-500` IS the Dolder green.
 * That is true in the app this folder came from, whose config remaps the whole scale, and false
 * here — the DRA keeps the stock palette and extends it, so the class would have rendered, in a
 * real blue, under a comment explaining that it was green. One of 41 such sites; see
 * `context/docs/whats-new.md` §1.
 */

interface Props {
    /** Overrides the default label where "New" is not the right word for the element. */
    label?: string;
}

export function NewMarker({ label = 'New' }: Props) {
    return (
        <span
            className="ml-1 inline-flex h-1.5 w-1.5 shrink-0 rounded-full bg-brand align-middle"
            title={label}
            role="img"
            aria-label={label}
        />
    );
}
